import moment from 'moment';

export const processes = [
  {
    part_id: null,
    qty: null,
    cost_in_rs: '',
    problem: '',
    reason_of_problem: '',
    cost_debit_to: '',
    remarks: '',
  },
];

export const initialState = {
  isSubmitted: false,
  is_admin_request_no: null,
  is_admin_request: null,
  report_prepared_by: null,
  report_approved_by: null,
  moduleData_Date: moment(),
  qa: '',
  authorised_by: '',
  processes: Array.from({ length: 5 }, () => ({ ...processes[0] })),
};
